export class EvaluationQuestion {
  questionId!: string;
  name!: string;
  answer?: string;
  comment?: string | undefined;
  taxPolicyId?: number;
  taxRuleId?: number;
  isActive?: boolean;
  securityQuestionAnswerId?: number;
  unsureAnswer?: boolean;
}
